import React from "react";

const TweetTable = ({
  exportTweetTableData,
  tweetData,
  isAnalyzing,
  processedData,
  analyzeSentiment,
  currentTweets,
  formatDate,
  removeTweet,
}) => {
  return (
    <>
      {tweetData.length > 0 && (
        <div className="mt-8">
          <div className="flex justify-between items-center">
            <p className="font-bold text-2xl text-orange-500">Fetched Tweets</p>
            <div>
              <button
                onClick={exportTweetTableData}
                className="px-4 py-2 mr-2 text-white bg-orange-500 rounded duration-200 hover:bg-orange-600"
              >
                Export Fetched Tweets
              </button>
              <button
                onClick={analyzeSentiment}
                className="px-4 py-2 text-white bg-orange-500 rounded duration-200 hover:bg-orange-600"
              >
                {isAnalyzing ? "Analysing..." : "Analyse"}
              </button>
            </div>
          </div>

          {/* Table Container */}
          <div className="overflow-x-auto mt-6">
            <table className="min-w-full table-auto text-sm lg:text-base border-collapse shadow-lg">
              {/* Table Header */}
              <thead className="bg-orange-500">
                <tr>
                  <th className="px-4 py-2 text-white font-bold text-left">
                    ID
                  </th>
                  <th className="px-4 py-2 text-white font-bold text-left">
                    Username
                  </th>
                  <th className="px-4 py-2 text-white font-bold text-left">
                    Text
                  </th>
                  <th className="px-4 py-2 text-white font-bold text-left">
                    Likes
                  </th>
                  <th className="px-4 py-2 text-white font-bold text-left">
                    Retweets
                  </th>
                  <th className="px-4 py-2 text-white font-bold text-left">
                    Tweet Date
                  </th>
                  <th className="px-4 py-2 text-white font-bold text-left">
                    Link
                  </th>
                  <th className="px-4 py-2 text-white font-bold text-left">
                    Action
                  </th>
                </tr>
              </thead>

              {/* Table Body */}
              <tbody>
                {currentTweets.map((tweet, index) => (
                  <tr
                    key={tweet.conversation_id_str}
                    className="bg-white border-b hover:bg-gray-50"
                  >
                    <td className="px-4 py-2">{tweet.conversation_id_str}</td>
                    <td className="px-4 py-2">{tweet.username}</td>
                    <td className="px-4 py-2">{tweet.full_text}</td>
                    <td className="px-4 py-2">{tweet.favorite_count}</td>
                    <td className="px-4 py-2">{tweet.retweet_count}</td>
                    <td className="px-4 py-2">
                      {formatDate(tweet.created_at)}
                    </td>
                    <td className="px-4 py-2">
                      <a
                        href={tweet.tweet_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-500 hover:underline"
                      >
                        View
                      </a>
                    </td>
                    <td className="px-4 py-2">
                      <button
                        onClick={() => removeTweet(index)}
                        className="px-4 py-1 text-white bg-red-500 rounded hover:bg-red-700"
                      >
                        Remove
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </>
  );
};

export default TweetTable;
